export const DEFAULT_MAX_RECOMMENDATIONS = 6;
export const LUMAPPS_RECO_ORIGIN = 'lumapps-recommendation';

export const SEARCH_HIERARCHICAL_SEPARATOR = '|';
export const SEARCH_HIERARCHICAL_JOIN_OPERATOR = ' > ';
